<template>
  <!-- <div style="width: 100%">
    <router-view />
  </div> -->
   <el-card style="min-heigh: 500px">
    <!-- 页面标题，卡片头 -->
    <div slot="header" class="clearfix">
      <span>土壤检测</span>
      <el-radio-group v-model="park" size="small" style="float: right">
        <el-radio-button v-for="park in parks" :label="park.id" :key="park.id">
          {{ park.name }}
        </el-radio-button>
      </el-radio-group>
    </div>
    <!-- 页面主体内容 -->
    <el-row>
      <div>
        <!-- irrigateSn = {{ irrigateSn }} -->
        
          
          <el-col :span="18">
            <el-row
              :gutter="2"
              style="
                display: flex;
                justify-content: space-between;
                margin-top: 5px;
              "
            >
              
            </el-row>
          </el-col>
        
      </div>
    </el-row>
    <el-row :gutter="20">
      <!-- 左侧地块选项 -->
      <el-col :span="4">
        <el-table
          ref="landSelector"
          :data="lands"
          highlight-current-row
          :show-header="false"
          @current-change="landSelected"
        >
          <el-table-column prop="name"></el-table-column>
        </el-table>
      </el-col>

      <!-- 右侧页面主体内容 -->
      <el-col v-show="lands.length != 0" :span="20">
        <monitor-soil :land-id="landId" :irrigate-sn="irrigateSn" />
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import { parkSearch } from '@/api/park.js'
import { getAreaData } from '@/api/land.js'

import MonitorSoil from './MonitorSoil'

export default {
  name: 'MonitorIndex',
  components: {MonitorSoil},
  data() {
    return {
      /**
       * 当前选中的园区id
       */
      park: undefined,
      /**
       * 当前企业下辖的园区信息列表
       */
      parks: [],
      /**
       * 当前选中园区内地块列表
       */
      lands: [],
      irrigateSn: undefined,
      /**
       * 室外气象设备sn
       */
      outdoorSn: undefined,
      /**
       * 室外气象数据，键值对
       */
      outdoorDatas: {},
      landId: undefined,
      outdoorDatasUrl: null,
    }
  },
  computed: {
    /**
     * 当前企业
     */
    currentEnterprise() {
      return this.$store.getters.currentEnterprise.id
    },
  },
  watch: {
    /**
     * 监测当前园区，如果发生变化，则刷新地块、园区气象等信息
     */
    park: function (parkId) {
    
        // 初始化地块列表
        this.refreshLands()
        // 获取园区采控设备信息
      
    },
  },
  filters: {
   
  },
  mounted() {
    // 初始化园区列表，把列表中首个园区设置为当前园区
    parkSearch({
      enterpriseId: this.currentEnterprise,
    }).then((resp) => {
      this.parks = resp.data.list
      this.park = this.parks[0].id
    })
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  },
  methods: {
   
   
    /**
     * 某个地块被选中
     */
    landSelected(row) {
      this.landId = row.id
    },
    /**
     * 根据当前园区，刷新地块列表（在园区初始化或切换时调用），并默认选中第一个地块
     */
    refreshLands() {
      getAreaData({
        enterpriseId: this.currentEnterprise.id,
        parkId: this.park,
      }).then((resp) => {
        this.lands = resp.data.list

        if (resp.data.list.length == 0) {
          return
        }
        if (this.lands.length != 0) {
          this.$refs.landSelector.setCurrentRow(this.lands[0])
          this.landId = this.lands[0].id
        }
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/monitor/soil/Index.vue